import { render, staticRenderFns } from "./addMarche.vue?vue&type=template&id=bf96fb22&scoped=true"
import script from "./addMarche.vue?vue&type=script&lang=js"
export * from "./addMarche.vue?vue&type=script&lang=js"
import style0 from "./addMarche.vue?vue&type=style&index=0&id=bf96fb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf96fb22",
  null
  
)

export default component.exports